/**
 * Amazon review UX: tabs (legacy) + listing-image recovery.
 *
 * Amazon's P/{ASIN} shortcut often returns a 1×1 pixel. Real photos are the
 * hashed /I/ URLs. When an <img> fails or lands as a 1×1, we walk
 * data-amz-fallbacks and finally swap in a brand-letter placeholder.
 */
(function () {
  function initTabs(root) {
    const tabs = root.querySelectorAll("[data-amz-tab]");
    const panels = root.querySelectorAll("[data-tab-panel]");
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach((t) => {
        const on = t.getAttribute("data-amz-tab") === id;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach((p) => {
        const on = p.getAttribute("data-tab-panel") === id;
        p.hidden = !on;
        p.classList.toggle("is-active", on);
      });
    }

    tabs.forEach((t) => {
      t.addEventListener("click", () => activate(t.getAttribute("data-amz-tab")));
    });

    const hash = (location.hash || "").replace("#", "");
    const fromHash = ["overview", "specs", "faq", "amazon", "related"].includes(hash)
      ? hash
      : "overview";
    activate(fromHash);
  }

  function placeholderFor(img) {
    const media = img.closest(".amz-aff-card__media, .amz-product-img-wrap, .amz-review-index__media");
    const letter =
      (img.closest(".amz-aff-card")?.querySelector(".amz-aff-card__brand")?.textContent || "A").trim().charAt(0) ||
      "A";
    img.classList.add("is-broken");
    if (media && !media.querySelector(".amz-aff-card__placeholder")) {
      const ph = document.createElement("div");
      ph.className = "amz-aff-card__placeholder";
      ph.setAttribute("aria-hidden", "true");
      ph.textContent = letter;
      media.appendChild(ph);
    }
  }

  function recoverImage(img) {
    if (img.dataset.amzBound) return;
    img.dataset.amzBound = "1";
    const queue = (img.getAttribute("data-amz-fallbacks") || "")
      .split("|")
      .map((s) => s.trim())
      .filter(Boolean)
      .filter((u) => u !== img.getAttribute("src"));

    function usable() {
      return img.naturalWidth >= 20 && img.naturalHeight >= 20;
    }

    function next() {
      if (usable()) {
        img.classList.add("is-loaded");
        img.classList.remove("is-broken");
        return;
      }
      const url = queue.shift();
      if (!url) {
        placeholderFor(img);
        return;
      }
      img.src = url;
    }

    img.addEventListener("load", () => {
      if (usable()) {
        img.classList.add("is-loaded");
        img.classList.remove("is-broken");
      } else {
        next();
      }
    });
    img.addEventListener("error", next);
    if (img.complete) next();
  }

  function boot() {
    document.querySelectorAll("[data-amazon-affiliate-page]").forEach(initTabs);
    document
      .querySelectorAll(
        "img[data-amz-fallbacks], img.amz-product-img, img.amz-aff-card__img, img.amz-review-index__img"
      )
      .forEach(recoverImage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
